import React from "react";
import { Route, Routes } from "react-router-dom";
import { PublicRoute, AdminRoute, SubAdminRoute } from "./routes/AuthRoute";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import AdminDash from "./pages/admin/AdminDash";
import NotFound from "./pages/NotFound";
import ResetPassword from "./pages/auth/ResetPassword";
import AutoLogout from "./routes/AutoLogout";
import Deposit from "./pages/admin/Deposit";
import AdminProfile from "./pages/admin/AdminProfile";
import EditUser from "./pages/admin/EditUser";
import DepositMoney from "./pages/admin/DepositMoney";
import Transactions from "./pages/admin/Transactions";
import KycAll from "./pages/admin/KycAll";
import KycDetails from "./pages/admin/KycDetails";
import Withdrawals from "./pages/admin/Withdrawals";
import UserDetails from "./pages/admin/UserDetails";
import AddBank from "./pages/admin/AddBank";
import Bank from "./pages/admin/Bank";
import AddWallet from "./pages/admin/AddWallet";
import WalletAddress from "./pages/admin/WalletAddress";
import BaseCurrency from "./pages/admin/BaseCurrency";
import WithdrawDetails from "./pages/admin/WithdrawDetails";
import TranDetails from "./pages/admin/TranDetails";
import SubAdmins from "./pages/admin/SubAdmins";
import Profit from "./pages/admin/Profit";
import Fund from "./pages/admin/Fund";
import FundDetails from "./pages/admin/FundDetails";
import AddFund from "./pages/admin/AddFund";
import AddClass from "./pages/admin/AddClass";
import FundRequest from "./pages/admin/FundRequest";
import FundRequestDetails from "./pages/admin/FundRequestDetails";
import Activities from "./pages/admin/Activities";
import AdminNotifications from "./pages/admin/AdminNotifications";
import WithdrawDetailsC from "./pages/admin/WithdrawDetailsC";
import DepositRequests from "./pages/admin/DepositRequests";
import DepositRequestDetails from "./pages/admin/DepositRequestDetails";
import Users from "./pages/admin/Users";

const App = () => {
  return (
    <>
      <AutoLogout />
      <Routes>
        {/* Public Routes (No authentication needed) */}
        <Route
          path="/"
          element={
            <PublicRoute>
              <Login />
            </PublicRoute>
          }
        />
        <Route
          path="/forgot-password"
          element={
            <PublicRoute>
              <ForgotPassword />
            </PublicRoute>
          }
        />
        <Route
          path="/reset-password-admin/:token"
          element={
            <PublicRoute>
              <ResetPassword />
            </PublicRoute>
          }
        />

        {/* Sub-Admin and Super-Admin Routes */}
        <Route
          path="/dashboard/admin"
          element={
            <SubAdminRoute>
              <AdminDash />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/deposit"
          element={
            <SubAdminRoute>
              <Deposit />
            </SubAdminRoute>
          }
        />
        {/* <Route
          path="/dashboard/admin/profile"
          element={
            <SubAdminRoute>
              <AdminProfile />
            </SubAdminRoute>
          }
        /> */}
        <Route
          path="/dashboard/admin/edit-user/:id"
          element={
            <SubAdminRoute>
              <EditUser />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/deposit-money/:id"
          element={
            <SubAdminRoute>
              <DepositMoney />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/transactions"
          element={
            <SubAdminRoute>
              <Transactions />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/All-kyc"
          element={
            <SubAdminRoute>
              <KycAll />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/kyc-details/:id"
          element={
            <SubAdminRoute>
              <KycDetails />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/withdrawals"
          element={
            <SubAdminRoute>
              <Withdrawals />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/withdraw-details/:id"
          element={
            <SubAdminRoute>
              <WithdrawDetails />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/deposit-requests"
          element={
            <SubAdminRoute>
              <DepositRequests />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/deposit-request-details/:id"
          element={
            <SubAdminRoute>
              <DepositRequestDetails />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/users"
          element={
            <SubAdminRoute>
              <Users />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/withdraw-details-c/:id"
          element={
            <SubAdminRoute>
              <WithdrawDetailsC />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/user-details/:id"
          element={
            <SubAdminRoute>
              <UserDetails />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/user-details/bank/:id"
          element={
            <SubAdminRoute>
              <Bank />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/add-bank/:id"
          element={
            <SubAdminRoute>
              <AddBank />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/add-wallet/:id"
          element={
            <SubAdminRoute>
              <AddWallet />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/user-details/wallet"
          element={
            <SubAdminRoute>
              <WalletAddress />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/base-currency/:id"
          element={
            <SubAdminRoute>
              <BaseCurrency />
            </SubAdminRoute>
          }
        />

        <Route
          path="/dashboard/admin/notifications"
          element={
            <SubAdminRoute>
              <AdminNotifications />
            </SubAdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/trans"
          element={
            <SubAdminRoute>
              <TranDetails />
            </SubAdminRoute>
          }
        />
        {/* <Route
          path="/dashboard/admin/admin-wallets"
          element={
            <SubAdminRoute>
              <AdminWallet />
            </SubAdminRoute>
          }
        /> */}

        {/* Super-Admin Only Routes */}
        <Route
          path="/dashboard/admin/sub-admins"
          element={
            <AdminRoute>
              <SubAdmins />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/profit"
          element={
            <AdminRoute>
              <Profit />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/fund-management"
          element={
            <AdminRoute>
              <Fund />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/fund-details/:id"
          element={
            <AdminRoute>
              <FundDetails />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/add-fund"
          element={
            <AdminRoute>
              <AddFund />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/add-class/:fundId"
          element={
            <AdminRoute>
              <AddClass />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/fund-requests"
          element={
            <AdminRoute>
              <FundRequest />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/fund-request-details/:id"
          element={
            <AdminRoute>
              <FundRequestDetails />
            </AdminRoute>
          }
        />
        <Route
          path="/dashboard/admin/activities"
          element={
            <AdminRoute>
              <Activities />
            </AdminRoute>
          }
        />
        {/* Catch-all route for 404 pages */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default App;
